import { render, staticRenderFns } from "./DatosFacturacion.vue?vue&type=template&id=4f531b9c&scoped=true&"
import script from "./DatosFacturacion.vue?vue&type=script&lang=js&"
export * from "./DatosFacturacion.vue?vue&type=script&lang=js&"
import style0 from "./DatosFacturacion.vue?vue&type=style&index=0&id=4f531b9c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f531b9c",
  null
  
)

export default component.exports